import { useContext, useEffect, useState } from 'react';
import styles from './TitularArrendatario.module.scss';
import { BrDivider, BrSelect } from '@govbr-ds/react-components';
import { ICrumb } from '../../interfaces/ICrumb';
import { useNavigate } from 'react-router-dom';
import { DiefCfemContext } from '../../contexts/DiefCfemContext';
import TitularArrendatarioTab from './components/titularArrendatarioTab/titularArrendatarioTab';
import TituloSection from '../../components/tituloSection/tituloSection';
import { getAnoDeclaracao } from '../../utils/anoMesDeclaracao';

function TitularArrendatario() {
  const [ano, setAno] = useState(new Date().getFullYear().toString());
  const navigate = useNavigate();

  const context = useContext(DiefCfemContext);

  const onAnoChange = (valor: string) => {
    setAno(valor);
    sessionStorage.setItem('anoDeclaracao', valor);
  };

  useEffect(() => {
    const crumbs: ICrumb[] = [
      {
        isHome: true,
        label: 'home',
        onClick: () => {
          navigate('/');
        },
      },
      {
        active: true,
        label: 'Titular ou Arrendatario',
      },
    ];
    context?.setCrumbs(crumbs);

    const isPessoaNaoCadastrada = sessionStorage.getItem('isPessoaNaoCadastrada') === 'true';
    if (isPessoaNaoCadastrada) {
      navigate('/');
    }
  }, []);

  useEffect(() => {
    sessionStorage.setItem('anoDeclaracao', ano);
  }, [ano]);

  return (
    <>
      <BrDivider />
      <TituloSection type='titular-arrendatario' />
      <div className={styles.container}>
        <h4 className={styles.title}>Lista de Declarações</h4>
        <div className={styles.yearSelect}>
          <p className={styles.year}>Ano</p>
          <BrSelect
            className={styles.select}
            placeholder='Selecione...'
            value={ano}
            onChange={(valor: string) => onAnoChange(valor)}
            options={getAnoDeclaracao()}
          />
        </div>
        <div className={styles.titularTable}>
          <TitularArrendatarioTab year={ano} />
        </div>
      </div>
    </>
  );
}

export default TitularArrendatario;
